










import Vue from 'vue'
import VJsf from '@koumoul/vjsf'
import '@koumoul/vjsf/dist/main.css'
import schema from '@/schema/employmentContract.json'
import GenerateButton from '@/components/GenerateButton.vue'

const model = {}
const options = {}

export default Vue.extend({
  name: 'Form',
  components: {
    VJsf,
    GenerateButton
  },
  data() {
    return {
      model,
      schema,
      options,
      valid: null
    }
  }
})
